import { http } from './../../../libs/util'
import util from '../../../libs/util'
const { 
     qualification_subject_list,
     qualification_change_subject_status, 
     qualification_update_subject,
     qualification_histories_versions,
     qualification_update,
     qualification_create,
     qualification_item_list,
     qualification_change_status,
     qualification_file_url } = util.api || {}
// 获取主体资质列表
export function getSubjectListApi(params) {
    return http.get(qualification_subject_list, params)
}
// 更新主体资质
export function updateSubjectItemApi(params) {
    return http.post(qualification_update_subject, params)
}
// 更改主体资质冻结状态
export function changeSubjectItemStatusApi(params) {
    return http.post(qualification_change_subject_status, params)
}

// 查看资质历史版本
export function getHistoriesVersionsApi(params) {
    return http.get(qualification_histories_versions, params)
}

// 新增编辑资质
export function updateQualificationApi({isEdit, ...params}) {
    if (isEdit) {// 编辑
        return http.post_upload(qualification_update, params)
    }
    // 新增
    return http.post_upload(qualification_create, params)
}
// 资质列表
export function getQualificationListApi(params) {
    return http.get(qualification_item_list, params)
}
// 资质条目状态更改
export function changeQualificationItemStatusApi(params) {
    return http.post(qualification_change_status, params)
}

// 跳转下载资质
export function gotoQualificationFileApi(params) {
    return http.get(qualification_file_url, params)
}